export default{
    setToken(state, payload){
        state.token = payload;
    }
}